import React, { useState, useEffect } from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getOrganizations } from "../../Redux/actions/organization/getOrganization";
import { updateProfile,getUserSessionId } from "../../Redux/actions/user/";
import { loadUser } from "../../Redux/actions/user";
import Settings from "../PersonalSettings";
import Organizations from "../Organizations";
import Subscriptions from "../Subscriptions";
import UserHomePage from "../UserHomePage";
import EmptyScreen from "../../Assets/Empty-Screen.png";
import CustomModal from "../../UtilityComponents/customModal";
import DemoModal from "./demoModal";

function AppContainer(props) {
  const [ws, setWs] = useState(null);
  let { getOrganizations, user ,loadUser } = props;
  let { loading } = props.organizations;
  let check_user = user.check_user === undefined || user.check_user ===   true? true:false
  let [modal ,setModal] = useState(check_user)
  let [remindLater,setRemindMeLater] = useState(false)
  
  const toggle = (e) => {
      setModal(!modal);
  }

  const showModal = async (e) => {
    let payload={
      ...user,
      check_user:false
    }
    await updateProfile(payload,props.user)
    toggle()
  }

  const connect = () => {
    let { sub } = user;
    let ws = new WebSocket(
      `${window._env.REACT_APP_EMCONSOLE_WEBSOCKET_URL}/notifications?key=${sub}`
    );
    let connectInterval;
    let timeout = 250;

    // websocket onopen event listener
    ws.onopen = () => {
      console.log("connected websocket main component");

      setWs(ws);
      clearTimeout(connectInterval); // clear Interval on on open of websocket connection
    };

    // websocket onclose event listener
    ws.onclose = (e) => {
      console.log(
        `Socket is closed. Reconnect will be attempted in ${Math.min(
          10000 / 1000,
          (timeout + timeout) / 1000
        )} second.`,
        e.reason
      );

      timeout = timeout + timeout; //increment retry interval
      connectInterval = setTimeout(check, Math.min(10000, timeout)); //call check function after timeout
    };

    // websocket onerror event listener
    ws.onerror = (err) => {
      console.error(
        "Socket encountered error: ",
        err.message,
        "Closing socket"
      );

      ws.close();
    };

    ws.onmessage = (obj) => {
      let { event, msg } = JSON.parse(obj.data);
      if ("worker" === event) window.EventEmitter.emit("workerreload");
      window.EventEmitter.emit("notification", msg);
    };
  };

  const check = () => {
    if (!ws || ws.readyState == WebSocket.CLOSED) connect(); //check if websocket instance is closed, if so call `connect` function.
  };

  useEffect(() => {
    connect();
  }, []);

  useEffect(() => {
    let token = localStorage.getItem('id');
    const fetchData = async () => {
      if(!token){
        setRemindMeLater(true)
        let data =await getUserSessionId(props.user)
          localStorage.setItem('id', data.id);
      }
      else{
        let data =await getUserSessionId(props.user)
        if(data.id === token){
          setRemindMeLater(false)
        }
      }
      if(!(user.subscription_id === 1 || user.subscription_id === 0 ) ){
        // google signin user
        var subscription_id=0;
        await updateProfile({subscription_id, ...user}); 
        loadUser();
      }
      
    }
    fetchData()
  }, []);

  useEffect(() => {
    getOrganizations();
  }, [getOrganizations]);

  if (loading) {
    return (
      <div className="text-center mt-5">
        <img src={EmptyScreen} alt="empty Screen"></img>
        <p className="mt-5">Please wait ...</p>
      </div>
    );
  } else {
    return (
      <div>
        <Switch>
          <Route path="/subscriptions/manage" component={Subscriptions} />
          <Route path="/organizations" component={Organizations} />
          <Route path="/settings" component={Settings} />
          <Route path="/" component={UserHomePage} />
        </Switch>
        { modal === true && remindLater !== false? <CustomModal comp={<DemoModal  showModal = {()=>showModal()}  toggle={() => toggle()}/>} 
                   name = "Would you like to check out the video walkthrough of our E-Manager Console?"
                   toggle={() => toggle()}
                    modal={modal} /> : null 
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
  organizations: state.organizations,
});

const mapDispatchToProps = (dispatch) => ({
  getOrganizations: bindActionCreators(getOrganizations, dispatch),
  loadUser: bindActionCreators(loadUser, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);
